import { render } from "./VideoSocialFeed.vue?vue&type=template&id=1aab6040&scoped=true"
import script from "./VideoSocialFeed.vue?vue&type=script&lang=js"
export * from "./VideoSocialFeed.vue?vue&type=script&lang=js"

import "./VideoSocialFeed.vue?vue&type=style&index=0&id=1aab6040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aab6040"]])

export default __exports__